import HubClient from '@hei/signalr/HubClient';
import emit from '@hei/signalr/emit';
import { getAllConnectionIds } from '@hei/utils/signalRConnectionIdsCache';
import parseISODates from '@hei/utils/valueTransformers/parseISODates';
import getEventEmitter from '@hei/utils/getEventEmitter';

const parse = window.JSON.parse;

window.JSON.parse = (text: string, reviver?: (this: any, key: string, value: any) => any) => {
  const parsed = parse(text, reviver);
  return parseISODates(parsed);
};

window['signalRUtils'] = {
  HubClient,
  emit,
  getAllConnectionIds
};

window['getEventEmitter'] = getEventEmitter;
